import { useEffect, useState } from "react"
import styled from "styled-components"

import { useLazyGetReordersWidgetNewQuery } from "store/api/adminApi"

import WidgetsLayout from "layouts/WidgetsLayout"
import { calculateLastDays } from "layouts/WidgetsLayout/WidgetHeader"

import ReordersListModal from "./ReordersListModal"
import WidgetContent from "./WidgetContent"

const WidgetContentContainer = styled.div`
  cursor: pointer;
`

const ReordersWidget = () => {
  const [selectedDateRange, setSelectedDateRange] = useState(calculateLastDays(7))
  const [triggerGetReordersWidget, { isFetching, data }] = useLazyGetReordersWidgetNewQuery()
  const [showOrdersListModal, setShowOrdersListModal] = useState(false)

  const contentDate = data?.data
    ? [
        {
          title: "Contractors",
          value: data.data.contractors,
        },
        {
          title: "Number of reorders",
          value: data.data.reorders,
        },
        {
          title: "# of Thermostats / CWAs",
          value: `${data.data.thermostat_count} / ${data.data.cwa_count}`,
        },
      ]
    : []

  useEffect(() => {
    const fetchData = async () => {
      try {
        await triggerGetReordersWidget(
          {
            start_date: selectedDateRange[0],
            end_date: selectedDateRange[1],
          },
          true,
        )
      } catch (error) {
        console.error(error)
      }
    }

    fetchData()
  }, [selectedDateRange])

  const handleWidgetClick = () => {
    setShowOrdersListModal(true)
  }

  return (
    <>
      <WidgetsLayout title="Reorders" includeCustomRangeSelect onSelectDateRange={setSelectedDateRange}>
        <WidgetContentContainer onClick={handleWidgetClick}>
          <WidgetContent isFetching={isFetching} data={contentDate} />
        </WidgetContentContainer>
      </WidgetsLayout>
      {showOrdersListModal && (
        <ReordersListModal selectedDateRange={selectedDateRange} onClose={() => setShowOrdersListModal(false)} />
      )}
    </>
  )
}

export default ReordersWidget
